import React from 'react';
import { Template, Resource } from './types';

interface TemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (templateData: Template) => void;
  currentTemplate: Template | null;
  resources: Resource[];
}

const TemplateModal: React.FC<TemplateModalProps> = ({ 
  isOpen, 
  onClose, 
  onSave, 
  currentTemplate, 
  resources 
}) => {
  if (!isOpen) return null;

  const handleSubmit = () => {
    const nameInput = document.getElementById('template-name') as HTMLInputElement;
    const descriptionInput = document.getElementById('template-description') as HTMLTextAreaElement;
    // Logic for selected resources for 'Apply To' would be needed here

    const templateData: Template = {
      id: currentTemplate?.id || Date.now(),
      name: nameInput.value || (currentTemplate?.name || 'New Template'),
      description: descriptionInput.value || (currentTemplate?.description || ''),
    };
    onSave(templateData);
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="px-6 py-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900">
            {currentTemplate ? 'Edit Template' : 'Create New Template'}
          </h3>
          <button
            className="text-gray-400 hover:text-gray-500"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        
        <div className="p-6">
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}> {/* Prevent default form submission */}
            <div>
              <label htmlFor="template-name" className="block text-sm font-medium text-gray-700 mb-1">
                Template Name
              </label>
              <input
                type="text"
                id="template-name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                defaultValue={currentTemplate?.name || ''}
              />
            </div>
            
            <div>
              <label htmlFor="template-description" className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                id="template-description"
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                defaultValue={currentTemplate?.description || ''}
              ></textarea>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Apply To
              </label>
              <div className="mt-2 space-y-2 max-h-32 overflow-y-auto"> {/* Added scroll for many resources */}
                {resources.map(resource => (
                  <div key={resource.id} className="flex items-center">
                    <input
                      id={`resource-${resource.id}`}
                      type="checkbox"
                      className="h-4 w-4 text-[#3A5E63] focus:ring-[#3A5E63] border-gray-300 rounded"
                      // Add checked and onChange logic if this becomes interactive
                    />
                    <label htmlFor={`resource-${resource.id}`} className="ml-2 block text-sm text-gray-700">
                      {resource.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Template Events
              </label>
              <div className="bg-gray-50 p-3 rounded-lg">
                <div className="text-sm text-center text-gray-500 py-4">
                  {currentTemplate ? 'Template events will appear here' : 'Add events to create your template pattern'}
                </div>
                <button
                  type="button"
                  className="w-full text-center py-2 text-sm text-[#3A5E63] hover:text-[#2a4548] focus:outline-none mt-2"
                  // onClick logic to add events to template needed here
                >
                  + Add Event to Template
                </button>
              </div>
            </div>
          </form>
        </div>
        
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button
            type="button"
            className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-3"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-[#3A5E63] hover:bg-[#2a4548] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3A5E63]"
            onClick={handleSubmit}
          >
            {currentTemplate ? 'Update Template' : 'Create Template'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateModal; 